module.exports = __webpack_public_path__ + "media/images/site/16x16-147be853794153a564ec62085e47a6bb.png";